<template lang="pug">
div(class='h-12')
  BaseFormSelect(v-model='selectedBrand' :options='brandsList' :classes='{ input: "h-full" }')
</template>

<script>
export default defineNuxtComponent({
  name: 'DealerLocatorBrandSelector',
  setup() {
    const { $algolia } = useNuxtApp()

    // Set SearchProviders here so we don't have to do $algolia.searchContexts everywhere
    const dealerLocator = $algolia.searchContexts.dealerLocator
    const dealerLocatorBrands = $algolia.searchContexts.dealerLocatorBrands

    return {
      dealerLocator,
      dealerLocatorBrands,
      navigateTo,
    }
  },
  data() {
    return {
      brands: [],
      selectedBrand: '',
    }
  },
  watch: {
    '$route.query.brand'(newVal) {
      this.setBrand(newVal)
    },
    selectedBrand(newVal) {
      // set brand refinement values
      this.dealerLocator.indexes.forEach((index) => {
        index.clearRefinements()
        // This includes check makes sure that the brand selected is a valid brand
        if (newVal && this.brands.includes(newVal)) {
          index.addRefinements('brands.brand', newVal)

          let preferredBrandsFacet = 'preferredBrands'
          if (index.key === 'brand') preferredBrandsFacet = `NOT ${preferredBrandsFacet}`
          index.addRefinements(preferredBrandsFacet, newVal)
        }
      })

      // trigger new search
      this.dealerLocator.search()

      // Update page to new sort
      this.navigateTo({ query: { brand: newVal || undefined } })
    },
  },
  async mounted() {
    await this.getBrands()
    if (this.$route.query?.brand) this.setBrand(this.$route.query.brand)
  },
  computed: {
    brandsList() {
      // Turn the brands array into an object key value pair for FormKit data
      return this.brands.reduce(
        (acc, brand) => {
          acc[brand] = brand
          return acc
        },
        { '': 'All Brands' }
      )
    },
  },
  methods: {
    async getBrands() {
      try {
        // this is using a private method we use internally that gets the results but doesn't set the state.
        const { refinements } = await this.dealerLocatorBrands._search()

        // Get brand facet from search
        const brandFacetValues = refinements['brands.brand']

        // If we don't have any then return
        if (!brandFacetValues) return

        // Set brands equal to the values
        this.brands = brandFacetValues.map(({ value }) => value)
      } catch (error) {
        console.log('Unable to get brand facets')
      }
    },
    setBrand(brand) {
      if (this.brands.includes(brand))
        // This will make sure the selected brand
        this.selectedBrand = brand
    },
  },
})
</script>
